import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import { useFormatMoneda } from '../utils/moneda';

export default function Reportes() {
  const formatMoneda = useFormatMoneda();
  const [tab, setTab] = useState('cartera');
  const [cartera, setCartera] = useState([]);
  const [mora, setMora] = useState([]);
  const [cobradores, setCobradores] = useState([]);
  const [filtros, setFiltros] = useState({ fecha_desde: '', fecha_hasta: '' });

  useEffect(() => {
    if (tab === 'cartera') api.get('/reportes/cartera').then(r => setCartera(r.data)).catch(() => {});
    if (tab === 'mora') api.get('/reportes/mora').then(r => setMora(r.data)).catch(() => {});
    if (tab === 'cobradores') api.get('/reportes/cobros-por-cobrador', { params: filtros }).then(r => setCobradores(r.data)).catch(() => {});
  }, [tab, filtros]);

  async function descargarExcel() {
    try {
      const res = await api.get('/reportes/excel-cartera', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'cartera_saturnpro.xlsx';
      a.click();
    } catch {
      toast.error('Error al descargar reporte');
    }
  }

  const TABS = [
    { key: 'cartera', label: 'Cartera General' },
    { key: 'mora', label: 'Clientes en Mora' },
    { key: 'cobradores', label: 'Por Cobrador' },
  ];

  return (
    <div>
      <div style={styles.header}>
        <h2 style={styles.title}>Reportes</h2>
        <button style={styles.btnExcel} onClick={descargarExcel}>Descargar Excel</button>
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{ ...styles.tabBtn, background: tab === t.key ? '#38bdf8' : '#1e293b', color: tab === t.key ? '#0f172a' : '#94a3b8', fontWeight: tab === t.key ? 700 : 400 }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'cartera' && (
        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.thead}>
                <th>Cliente</th><th>Documento</th><th>Zona</th><th>Monto</th><th>Cuotas</th><th>Pagado</th><th>Saldo</th><th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {cartera.map((c, i) => (
                <tr key={i} style={styles.row}>
                  <td>{c.nombre}</td><td>{c.documento}</td><td>{c.zona || '-'}</td>
                  <td>{formatMoneda(parseFloat(c.monto))}</td>
                  <td>{c.cuotas_pagadas}/{c.total_cuotas}</td>
                  <td style={{ color: '#34d399' }}>{formatMoneda(parseFloat(c.total_pagado || 0))}</td>
                  <td style={{ color: '#fbbf24' }}>{formatMoneda(parseFloat(c.saldo_pendiente || 0))}</td>
                  <td>{c.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {cartera.length === 0 && <p style={styles.empty}>Sin datos</p>}
        </div>
      )}

      {tab === 'mora' && (
        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.thead}>
                <th>Cliente</th><th>Documento</th><th>Teléfono</th><th>Zona</th><th>Cuotas vencidas</th><th>Valor mora</th>
              </tr>
            </thead>
            <tbody>
              {mora.map((c, i) => (
                <tr key={i} style={styles.row}>
                  <td>{c.nombre}</td><td>{c.documento}</td><td>{c.telefono || '-'}</td><td>{c.zona || '-'}</td>
                  <td style={{ color: '#f87171' }}>{c.cuotas_vencidas}</td>
                  <td style={{ color: '#f87171' }}>{formatMoneda(parseFloat(c.valor_mora))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {mora.length === 0 && <p style={styles.empty}>No hay clientes en mora</p>}
        </div>
      )}

      {tab === 'cobradores' && (
        <div>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
            <div style={styles.field}>
              <label style={styles.label}>Desde</label>
              <input type="date" value={filtros.fecha_desde} onChange={e => setFiltros({ ...filtros, fecha_desde: e.target.value })} style={styles.inputSm} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Hasta</label>
              <input type="date" value={filtros.fecha_hasta} onChange={e => setFiltros({ ...filtros, fecha_hasta: e.target.value })} style={styles.inputSm} />
            </div>
          </div>
          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead><tr style={styles.thead}><th>Cobrador</th><th>Total Cobros</th><th>Total Recaudado</th></tr></thead>
              <tbody>
                {cobradores.map((c, i) => (
                  <tr key={i} style={styles.row}>
                    <td>{c.cobrador}</td>
                    <td>{c.total_cobros}</td>
                    <td style={{ color: '#34d399' }}>{formatMoneda(parseFloat(c.total_recaudado || 0))}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {cobradores.length === 0 && <p style={styles.empty}>Sin datos</p>}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  title: { margin: 0, color: 'var(--text-1)', fontSize: '1.5rem' },
  btnExcel: { background: '#16a34a', color: '#fff', border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', fontWeight: 700, cursor: 'pointer' },
  tabBtn: { border: 'none', borderRadius: '8px', padding: '0.6rem 1.2rem', cursor: 'pointer', fontSize: '0.9rem' },
  tableWrap: { background: 'var(--bg-card)', borderRadius: '10px', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: 'var(--bg-app)', color: 'var(--text-2)', textAlign: 'left', fontSize: '0.8rem' },
  row: { borderBottom: '1px solid var(--border)', color: 'var(--text-1s)', fontSize: '0.9rem' },
  empty: { textAlign: 'center', color: 'var(--text-3)', padding: '2rem' },
  field: { marginBottom: 0 },
  label: { display: 'block', color: 'var(--text-2)', fontSize: '0.85rem', marginBottom: '0.3rem' },
  inputSm: { padding: '0.5rem', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-1)', fontSize: '0.9rem' }
};
